import { apiBaseUrl } from "./config"

const baseUrl = `${apiBaseUrl}/roles`;

async function getRoles(type) {
  let url = `${baseUrl}`;
  if (type) {
    url += `?type=${type}`;
  }
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

async function createRole(token, { label, level }) {
  const r = await fetch(baseUrl, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, level }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.message || 'Error al crear el rol.');
  return data;
}

async function deleteRole(token, role_id) {
  const r = await fetch(`${baseUrl}/${role_id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.message || 'Error al eliminar el rol.');
  return data;
}

const levels = {
  nacional: 1,
  region: 2,
  diocesis: 3,
  comunidad: 4,
  equipo: 5
}

function getPageOrgLevel(params) {
  let level = levels.nacional;
  if (params.regionId) {
    level = levels.region;
  }
  else if (params.diocesisId) {
    level = levels.diocesis;
  }
  else if (params.comunidadId) {
    level = levels.comunidad;
  }
  else if (params.teamId) {
    level = levels.equipo;
  }
  return level;
}

export {
  getRoles,
  createRole,
  deleteRole,
  levels,
  getPageOrgLevel
};
